// extracted by mini-css-extract-plugin
module.exports = {"mobileContainer":"ComboCartMobile-mobileContainer-09fa","content":"ComboCartMobile-content-09fa","footer":"ComboCartMobile-footer-09fa"};